export const initialState = {
  localizations: [],
  filters: {},
  loading: false
};
